<template>
  <div class="home-container">
    <div class="welcome-section">
      <h1>Acceso Rápido</h1>
      <p>{{ mensaje }}</p>
    </div>

    <!-- Dashboard según el rol -->
    <div class="dashboard-grid">
      
      <!-- SECCIÓN ACADÉMICA -->
      <div v-if="mostrarSeccionAcademica" class="dashboard-section">
        <h2>COMPONENTES ACADÉMICOS</h2>
        <div class="cards-grid">
          <!-- Talleres en lugar de Grados -->
          <div class="dashboard-card" @click="navigateTo('talleres')">
            <div class="card-icon">
              <i class="icon-talleres"></i>
            </div>
            <div class="card-content">
              <div class="card-number">{{ conteoTalleres }}</div>
              <div class="card-label">TALLERES</div>
            </div>
            <button class="card-action">Gestionar</button>
          </div>

          <!-- Estudiantes -->
          <div class="dashboard-card" @click="navigateTo('alumnos')">
            <div class="card-icon estudiantes">
              <i class="icon-students"></i>
            </div>
            <div class="card-content">
              <div class="card-number">{{ conteoEstudiantes }}</div>
              <div class="card-label">ESTUDIANTES</div>
            </div>
            <button class="card-action">Agregar</button>
          </div>

          <!-- Reporte General -->
          <div class="dashboard-card" @click="navigateTo('reportegeneral')">
            <div class="card-icon reportes">
              <i class="icon-reports"></i>
            </div>
            <div class="card-content">
              <div class="card-number"></div>
              <div class="card-label">REPORTE GENERAL</div>
            </div>
            <button class="card-action">Ver</button>
          </div>

          <!-- Maestros/Coordinación -->
          <div class="dashboard-card" @click="navigateTo('coordinacion')">
            <div class="card-icon maestros">
              <i class="icon-teachers"></i>
            </div>
            <div class="card-content">
              <div class="card-number"></div>
              <div class="card-label">MAESTROS</div>
            </div>
            <button class="card-action">Gestionar</button>
          </div>
        </div>
      </div>

      <!-- SECCIÓN ADMINISTRATIVA -->
      <div v-if="mostrarSeccionAdministrativa" class="dashboard-section">
         <h2>COMPONENTES ADMINISTRATIVOS</h2>
        <div class="cards-grid">
          <!-- Usuarios -->
          <div v-if="puedeVerUsuarios" class="dashboard-card" @click="navigateTo('usuarios')">
            <div class="card-icon usuarios">
              <i class="icon-users"></i>
            </div>
            <div class="card-content">
              <div class="card-number">{{ conteoUsuarios }}</div>
              <div class="card-label">USUARIOS</div>
            </div>
            <button class="card-action">Agregar</button>
          </div>

          <!-- Roles -->
          <div v-if="puedeVerRoles" class="dashboard-card" @click="navigateTo('roles')">
            <div class="card-icon roles">
              <i class="icon-roles"></i>
            </div>
            <div class="card-content">
              <div class="card-number">{{ conteoRoles }}</div>
              <div class="card-label">ROLES</div>
            </div>
            <button class="card-action">Agregar</button>
          </div>

          <!-- Permisos -->
          <div v-if="puedeVerRoles" class="dashboard-card" @click="navigateTo('permisos')">
            <div class="card-icon permisos">
              <i class="icon-permissions"></i>
            </div>
            <div class="card-content">
              <div class="card-number">{{ conteoPermisos }}</div>
              <div class="card-label">PERMISOS</div>
            </div>
            <button class="card-action">VER</button>
          </div>

          <!-- Pagos -->
          <div v-if="puedeVerPagos" class="dashboard-card" @click="navigateTo('pagos')">
            <div class="card-icon pagos">
              <i class="icon-payments"></i>
            </div>
            <div class="card-content">
              <div class="card-number"></div>
              <div class="card-label">PAGOS</div>
            </div>
            <button class="card-action">Gestionar</button>
          </div>

          <!-- Reporte de Asistencias (Solo para administrativos y coordinación) -->
          <div v-if="puedeVerReporteAsistencias" class="dashboard-card" @click="navigateTo('asistencia-reporte')">
            <div class="card-icon asistencias">
              <i class="icon-asistencias"></i>
            </div>
            <div class="card-content">
              <div class="card-number"></div>
              <div class="card-label">ASISTENCIAS</div>
            </div>
            <button class="card-action">Ver Reporte</button>
          </div>
        </div>
      </div>

      <!-- SECCIÓN CAJERO (solo para cajeros) -->
      <div v-if="esCajero" class="dashboard-section">
        <h2>GESTIÓN DE PAGOS</h2>
        <div class="cards-grid">
          <!-- Pagos para Cajero -->
          <div class="dashboard-card" @click="navigateTo('pagos')">
            <div class="card-icon pagos">
              <i class="icon-payments"></i>
            </div>
            <div class="card-content">
              <div class="card-number"></div>
              <div class="card-label">PAGOS</div>
            </div>
            <button class="card-action">Gestionar</button>
          </div>
        </div>
      </div>

      <!-- SECCIÓN COORDINACIÓN (solo para coordinadores) -->
      <div v-if="esCoordinacion" class="dashboard-section">
        <h2>GESTIÓN DE COORDINACIÓN</h2>
        <div class="cards-grid">
          <!-- Pagos para Coordinador -->
          <div class="dashboard-card" @click="navigateTo('pagos')">
            <div class="card-icon pagos">
              <i class="icon-payments"></i>
            </div>
            <div class="card-content">
              <div class="card-number"></div>
              <div class="card-label">PAGOS</div>
            </div>
            <button class="card-action">Gestionar</button>
          </div>

          <!-- Reporte de Asistencias para Coordinadores -->
          <div v-if="puedeVerReporteAsistencias" class="dashboard-card" @click="navigateTo('asistencia-reporte')">
            <div class="card-icon asistencias">
              <i class="icon-asistencias"></i>
            </div>
            <div class="card-content">
              <div class="card-number"></div>
              <div class="card-label">ASISTENCIAS</div>
            </div>
            <button class="card-action">Ver Reporte</button>
          </div>
        </div>
      </div>

      <!-- SECCIÓN TALLERES (solo para profesores) -->
      <div v-if="esMaestro && talleres.length > 0" class="dashboard-section">
        <h2>MIS TALLERES</h2>
        <div class="talleres-grid">
          <div v-for="(taller, index) in talleres" :key="taller.id" 
               class="taller-card" 
               @click="navigateToTaller(index)">
            <div class="taller-header">
              <h3>{{ taller.descripcion }}</h3>
            </div>
            <div class="taller-info">
              <div class="taller-horarios">
                <span v-for="horario in taller.horarios" :key="horario" class="horario-badge">
                  {{ horario }}
                </span>
              </div>
            </div>
            <button class="taller-action">Ver Taller</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiFetch } from '../restapi.js';

export default {
  name: 'HomeLayout',
  data() {
    return {
      conteoTalleres: 0,
      conteoEstudiantes: 0,
      conteoUsuarios: 0,
      conteoRoles: 0,
      conteoPermisos: 0,
      conteoReportes: 0,
      conteoMaestros: 0,
      talleres: [],
      rol: localStorage.getItem('rol') || '',
      nombre: localStorage.getItem('nombre') || 'Usuario',
      permisos: {}
    };
  },
  computed: {
    mensaje() {
      if (this.esCajero) {
        return `Bienvenido/a ${this.nombre}, gestiona los pagos del sistema.`;
      } else if (this.esMaestro) {
        return `Bienvenido/a ${this.nombre}, aquí puedes gestionar tus talleres y alumnos.`;
      } else if (this.esAdministrador) {
        return `Bienvenido/a ${this.nombre}, panel de administración del sistema.`;
      }
      return `Bienvenido/a ${this.nombre}, accede a las funciones disponibles.`;
    },
    
    esCajero() {
      return this.rol.toLowerCase().includes('cajero');
    },
    
    esMaestro() {
      return this.rol.toLowerCase().includes('maestro') || this.rol.toLowerCase().includes('profesor');
    },
    
    esAdministrador() {
      return this.rol.toLowerCase().includes('admin') || this.rol.toLowerCase().includes('coordinador');
    },
    
    esCoordinacion() {
      const rolLower = this.rol.toLowerCase();
      return rolLower.includes('coordinador') || rolLower.includes('coordinacion');
    },
    
    mostrarSeccionAcademica() {
      return !this.esMaestro && !this.esCajero; // Mostrar para administradores y coordinadores, no para cajeros
    },
    
    mostrarSeccionAdministrativa() {
      return this.esAdministrador && !this.esCajero; // No mostrar para cajeros
    },
    
    puedeVerUsuarios() {
      const permisosUsuarios = this.permisos['/usuarios'] || [];
      return permisosUsuarios.some(p => p.Descripcion === 'Mostrar Lista Usuarios');
    },
    
    puedeVerRoles() {
      const permisosRoles = this.permisos['/roles'] || [];
      return permisosRoles.some(p => p.Descripcion === 'Mostrar Lista Roles');
    },

    puedeVerPagos() {
      const permisosPagos = this.permisos['/pagos'] || [];
      return permisosPagos.some(p => p.Descripcion === 'Mostrar Lista Pagos de Alumnos');
    },

    // Verificar si puede ver reporte de asistencias (deshabilitado en Home)
    puedeVerReporteAsistencias() {
      return false; // No mostrar en Home, solo en SidebarMenu
    },
    
    // Verificar otros permisos administrativos (para mantener funcionalidad existente)
    puedeVerSeccionAdministrativa() {
      // Permitir acceso a usuarios con rol de maestro, coordinación o administrativos
      const rolLower = this.rol.toLowerCase();
      
      // Si es maestro, coordinador o admin, puede acceder
      if (rolLower.includes('maestro') || 
          rolLower.includes('profesor') || 
          rolLower.includes('coordinador') || 
          rolLower.includes('admin')) {
        return true;
      }
      
      // Verificar permisos específicos como fallback
      const permisosCoordinacion = this.permisos['/coordinacion'] || [];
      const puedeVerCoordinacion = permisosCoordinacion.some(p => p.Descripcion === 'Mostrar Lista Coordinacion');
      
      const permisosTalleres = this.permisos['/talleres'] || [];
      const tienePermisosTalleres = permisosTalleres.some(p => p.Descripcion === 'Mostrar Lista Talleres');
      
      return puedeVerCoordinacion || tienePermisosTalleres;
    }
  },
  
  mounted() {
    this.cargarPermisos();
    this.cargarTalleres();
    this.cargarEstadisticas();
  },
  
  methods: {
    cargarPermisos() {
      try {
        const permisosData = localStorage.getItem('permisos');
        if (permisosData) {
          this.permisos = JSON.parse(permisosData);
        }
      } catch (e) {
        this.permisos = {};
      }
    },
    
    cargarTalleres() {
      try {
        const talleresData = localStorage.getItem('talleres');
        if (talleresData) {
          this.talleres = JSON.parse(talleresData);
        }
      } catch (e) {
        this.talleres = [];
      }
    },
    
    async cargarEstadisticas() {
      // Cargar estadísticas básicas para el dashboard
      if (this.puedeVerUsuarios) {
        await this.obtenerConteoUsuarios();
      }
      if (this.puedeVerRoles) {
        await this.obtenerConteoRoles();
      }
      await this.obtenerConteoEstudiantes();
      await this.obtenerConteoTalleres();
      
      // Inicializar conteos adicionales
      this.conteoReportes = 15; // Valor por defecto para reportes
      this.conteoMaestros = 25; // Valor por defecto para maestros
      this.conteoPagos = 120; // Valor por defecto para pagos
    },
    
    async obtenerConteoUsuarios() {
      try {
        const response = await apiFetch('/usuarios/ObtenerUsuariosPaginado?page=1&pageSize=1', {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        const data = await response.json();
        this.conteoUsuarios = data.total || 0;
      } catch (err) {
        this.conteoUsuarios = 0;
      }
    },
    
    async obtenerConteoRoles() {
      try {
        const response = await apiFetch('/roles/ObtenerRolesPaginados?page=1&pageSize=1', {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        const data = await response.json();
        this.conteoRoles = data.total || 0;
        this.conteoPermisos = 77; // Número fijo como en la imagen
      } catch (err) {
        this.conteoRoles = 0;
        this.conteoPermisos = 77;
      }
    },
    
    async obtenerConteoEstudiantes() {
      try {
        const response = await apiFetch('/alumnos/ObtenerAlumnosPaginado?page=1&pageSize=1', {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        const data = await response.json();
        this.conteoEstudiantes = data.total || 0;
      } catch (err) {
        this.conteoEstudiantes = 448; // Valor por defecto como en la imagen
      }
    },
    
    async obtenerConteoTalleres() {
      try {
        const response = await apiFetch('/talleres/ObtenerTalleresPaginado?page=1&pageSize=1', {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        const data = await response.json();
        this.conteoTalleres = data.total || 0;
      } catch (err) {
        this.conteoTalleres = 0;
      }
    },
    
    navigateTo(route) {
      const routeMap = {
        talleres: '/talleres',
        alumnos: '/alumnos',
        usuarios: '/usuarios',
        roles: '/roles',
        permisos: '/roles', // Los permisos se ven en la vista de roles
        reportegeneral: '/reportegeneral',
        coordinacion: '/coordinacion',
        pagos: '/pagos',
        'asistencia-reporte': '/asistencia-reporte'
      };
      
      if (routeMap[route]) {
        this.$router.push(routeMap[route]);
      }
    },
    
    navigateToTaller(index) {
      const tallerRoutes = {
        0: '/mitaller',
        1: '/mitaller2',
        2: '/mitaller3'
      };
      
      if (tallerRoutes[index]) {
        this.$router.push(tallerRoutes[index]);
      }
    }
  }
};
</script>

<style scoped>
.home-container {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.welcome-section {
  text-align: center;
  margin-bottom: 3rem;
}

.welcome-section h1 {
  color: #2c3e50;
  font-size: 2.5rem;
  margin-bottom: 1rem;
  font-weight: 300;
}

.welcome-section p {
  color: #7f8c8d;
  font-size: 1.2rem;
}

.dashboard-section {
  margin-bottom: 3rem;
}

.dashboard-section h2 {
  color: #34495e;
  font-size: 1.2rem;
  margin-bottom: 1.5rem;
  text-align: center;
  font-weight: 600;
}

.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
}

.dashboard-card {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  text-align: center;
}

.dashboard-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.15);
}

.card-icon {
  width: 80px;
  height: 80px;
  border-radius: 12px;
  background: #efc300;
  margin: 0 auto 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.5rem;
  color: white;
}

.card-content {
  margin-bottom: 1.5rem;
}

.card-number {
  font-size: 2.5rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 0.5rem;
}

.card-label {
  font-size: 1rem;
  color: #7f8c8d;
  font-weight: 600;
}

.card-action {
  background: #0a2860;
  color: white;
  border: none;
  padding: 0.8rem 2rem;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
}


/* Sección de talleres para maestros */
.talleres-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
}

.taller-card {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  cursor: pointer;
  transition: transform 0.3s ease;
  border-left: 4px solid #3498db;
}

.taller-card:hover {
  transform: translateY(-3px);
}

.taller-header {
  display: flex;
  justify-content: space-between;
  align-items: start;
  margin-bottom: 1rem;
}

.taller-header h3 {
  color: #2c3e50;
  margin: 0;
  font-size: 1.2rem;
}

.taller-students {
  color: #7f8c8d;
  font-size: 0.9rem;
}

.taller-horarios {
  margin-bottom: 1rem;
}

.horario-badge {
  background: #ecf0f1;
  color: #2c3e50;
  padding: 0.3rem 0.8rem;
  border-radius: 15px;
  font-size: 0.8rem;
  margin-right: 0.5rem;
}

.taller-action {
  background: #3498db;
  color: white;
  border: none;
  padding: 0.6rem 1.5rem;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  width: 100%;
}

.taller-action:hover {
  background: #2980b9;
}

/* Iconos CSS (usando pseudo-elementos) */
.icon-workshop::before { content: "�"; }
/* Iconos CSS (usando pseudo-elementos) */
.icon-talleres::before { content: "⚽🎨"; }
.icon-students::before { content: "👥"; }
.icon-users::before { content: "👤"; }
.icon-roles::before { content: "🔐"; }
.icon-permissions::before { content: "🔑"; }
.icon-reports::before { content: "📊"; }
.icon-teachers::before { content: "👨‍🏫"; }
.icon-payments::before { content: "💰"; }
.icon-asistencias::before { content: "📋"; }

/* Responsive */
@media (max-width: 768px) {
  .cards-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .dashboard-card {
    padding: 1.5rem;
  }
  
  .welcome-section h1 {
    font-size: 2rem;
  }
}
</style>
